import React from 'react';
import close from '../img/deelo_close.svg';

interface ModalProps {
  children: React.ReactNode;
  isOpen: boolean;
  closeModal?: () => void;
  className?: string;
  disableClickOutside?: boolean;
  showClose?: boolean;
}

function Modal({ children, isOpen, closeModal, className, disableClickOutside = false, showClose = true }: ModalProps) {
  if (!isOpen) {
    return null;
  }

  const handleClickOutside = (e: React.MouseEvent<HTMLDivElement>) => {
    if (disableClickOutside) {
      return;
    }
    if (closeModal && e.target instanceof HTMLElement && e.target.classList.contains('scrollable-content')) {
      closeModal();
    }
  };

  return (
    <div className={`modal ${className || ''}`} onClick={handleClickOutside}>
      <div className="scrollable-content">
        <div className="box">
          {closeModal && showClose && (
            <div className="close" onClick={closeModal}>
              <img src={close} alt="" />
            </div>
          )}
          {children}
        </div>
      </div>
    </div>
  );
}

export default Modal;

